/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrebuiltCompositeManifestDto } from './PrebuiltCompositeManifestDto';
import {
    PrebuiltCompositeManifestDtoFromJSON,
    PrebuiltCompositeManifestDtoFromJSONTyped,
    PrebuiltCompositeManifestDtoToJSON,
    PrebuiltCompositeManifestDtoToJSONTyped,
} from './PrebuiltCompositeManifestDto';

/**
 * 
 * @export
 * @interface PrebuiltPackCatalogEntryDto
 */
export interface PrebuiltPackCatalogEntryDto {
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    packSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    approximateTaskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    approximateMilestoneCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    coveredControlIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    planTaskPreviewTitles?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    featured?: boolean;
    /**
     * 
     * @type {PrebuiltCompositeManifestDto}
     * @memberof PrebuiltPackCatalogEntryDto
     */
    compositeManifest?: PrebuiltCompositeManifestDto;
}

/**
 * Check if a given object implements the PrebuiltPackCatalogEntryDto interface.
 */
export function instanceOfPrebuiltPackCatalogEntryDto(value: object): value is PrebuiltPackCatalogEntryDto {
    return true;
}

export function PrebuiltPackCatalogEntryDtoFromJSON(json: any): PrebuiltPackCatalogEntryDto {
    return PrebuiltPackCatalogEntryDtoFromJSONTyped(json, false);
}

export function PrebuiltPackCatalogEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrebuiltPackCatalogEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'packSlug': json['packSlug'] == null ? undefined : json['packSlug'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'approximateTaskCount': json['approximateTaskCount'] == null ? undefined : json['approximateTaskCount'],
        'approximateMilestoneCount': json['approximateMilestoneCount'] == null ? undefined : json['approximateMilestoneCount'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'coveredControlIds': json['coveredControlIds'] == null ? undefined : json['coveredControlIds'],
        'planTaskPreviewTitles': json['planTaskPreviewTitles'] == null ? undefined : json['planTaskPreviewTitles'],
        'featured': json['featured'] == null ? undefined : json['featured'],
        'compositeManifest': json['compositeManifest'] == null ? undefined : PrebuiltCompositeManifestDtoFromJSON(json['compositeManifest']),
    };
}

export function PrebuiltPackCatalogEntryDtoToJSON(json: any): PrebuiltPackCatalogEntryDto {
    return PrebuiltPackCatalogEntryDtoToJSONTyped(json, false);
}

export function PrebuiltPackCatalogEntryDtoToJSONTyped(value?: PrebuiltPackCatalogEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': value['kind'],
        'packSlug': value['packSlug'],
        'title': value['title'],
        'description': value['description'],
        'approximateTaskCount': value['approximateTaskCount'],
        'approximateMilestoneCount': value['approximateMilestoneCount'],
        'capabilityDomain': value['capabilityDomain'],
        'frameworkSlug': value['frameworkSlug'],
        'coveredControlIds': value['coveredControlIds'],
        'planTaskPreviewTitles': value['planTaskPreviewTitles'],
        'featured': value['featured'],
        'compositeManifest': PrebuiltCompositeManifestDtoToJSON(value['compositeManifest']),
    };
}

